import { Location } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { PersonSearchService } from 'src/app/_services/person-search.service';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { environment } from "../../../environments/environment";
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { TalentInsightsReqHandlerService } from 'src/app/_services/talent-insights-req-handler.service';
import { AggReqObjectHandlerService } from 'src/app/_services/agg-req-object-handler.service';
import { AggregationService } from 'src/app/_services/aggregation.service';
import { FilterDataHandlerService } from 'src/app/_services/filter-data-handler.service';
import { HashService } from 'src/app/_services/hash.service';
import { GeneralConstants } from 'src/app/constants/GeneralConstants';
import { TalentInsightsService } from 'src/app/_services/talent-insights.service';
import { TIAggRequest } from 'src/app/common-interfaces-classes/TIAggRequest';

declare var google;
const CONTINENT_MAP = {
  "asia": "142",
  "south america": "005",
  "north america": "021",
  "africa": "002",
  "oceania": "009",
  "europe": "150"
}
@Component({
  selector: 'app-report-location-tab',
  templateUrl: './report-location-tab.component.html',
  styleUrls: ['./report-location-tab.component.scss']
})
export class ReportLocationTabComponent implements OnInit {

  constructor(private personSearchService: PersonSearchService, private location: Location, private localstorageservice: LocalStorageService, 
    private router: Router, private talentInsightsReqHandlerService: TalentInsightsReqHandlerService,
    private aggReqObjectHandlerService: AggReqObjectHandlerService, private aggService: AggregationService,
    private filterDataHandlerService: FilterDataHandlerService,
    private hashService: HashService, private talentInsightsService: TalentInsightsService) { }

  companyDetails: any;
  currentCompanyName: any;
  dataSourceWorkCountry: any = [];
  topLocations: any[] = [];
  
  locations: any = [];
  locationsData: any = [];
  @ViewChild('locationTbSort') locationTbSort: MatSort;
  
  displayedColumns: string[] = ['key', 'doc_count', 'recent_hires'];
  aggregatescount: number = 50;
  pagination: boolean = true;

  /**Size of page */
  pageSize = 10;
  /**Starting index in each page */
  start: number = 0;
  /**Ending page in each page */
  end: number = 10;
  /**current page */
  currentPage = 1;
  /** Total data points */
  totalCount = 0;
  /** */
  locationAPiCalled: boolean = false;
  talentfilterdata: any = {};
  selectedContinent:string = 'World';

  subscriptions: Array<Subscription> = [];
  /**Sorted data of total pages */
  locationSortData: any;
  locationsdataAI: any;  
  totalResultCount: number = 0;

  insightsExportSubscription: Subscription = null;

  get isLocationEurope() {
    return this.localstorageservice.getItem('talentRegion') == 'europe';
  }

  ngOnInit(): void {
    this.router.events.subscribe(e => {
      const navigation = this.router.getCurrentNavigation();
      // We are getting this value mostly undefined. Could be because of mostly removing use of talentfilterdata in previous tab.
      this.talentfilterdata = navigation.extras.state;
    });

    // const locationsubscribe =  this.personSearchService.gettalentinsights.subscribe((response) => this.setUpdatedData(response));
    // this.subscriptions.push(locationsubscribe);

    this.setUpdatedData()
    const filterMethodEvent = this.filterDataHandlerService.filterMethodEvent.subscribe(_methodDetails => this.setUpdatedData());
    this.subscriptions.push(filterMethodEvent);

    // subscribe to insights-export subject for processing request from parent
    this.insightsExportSubscription = this.talentInsightsService.insightsExportRequestEvent.subscribe((requestData: { type?: string, action?: string, data?: { currentTab?: string } }) => {
      if(requestData && requestData.type === 'SIGNAL') {
        this.shareDataForInsightsExport(requestData);
      }
    });
    this.subscriptions.push(this.insightsExportSubscription);
  }

  private setUpdatedData(talentFilterData?: any) {
    if (talentFilterData) {
      this.talentfilterdata = talentFilterData;
    }
    this.start = 0;
    this.end = 10;
    this.currentPage = 1;
    console.log("filters",this.talentfilterdata);
    this.personSearchService.setTalentinsightsFilterAI(this.filterDataHandlerService.fetchFilterData)
    this.getTopLocationsV2();
  }

  /**
   * Legacy method. 
   * To be removed once getTopLocationsV2 and tested and stable
   */
  getTopLocations() {
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = "location";
    aggReq.aggregatescount = this.aggregatescount;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);

    this.personSearchService.getTotalAggs(aggReq).subscribe((response) => {
      this.locationAPiCalled = true;
      const tempData = response?.data?.aggregations?.location;
      this.totalResultCount = response.data.totalresultscount;
      this.locationSortData = tempData;
      this.totalCount = tempData.length;
      this.locationsData = this.locationSortData?.slice(this.start, this.end);
      this.locations = new MatTableDataSource(this.locationsData);
      this.locations.sort = this.locationTbSort;
      this.markMap();
      this.manualSort();
      this.getlocationsai(this.locationSortData)
    });
  }

  getTopLocationsV2() {
    this.aggReqObjectHandlerService.setShareRequestObject(new TIAggRequest());
    const request = this.aggService.getRequestWithFilters();
    request.aggregatetype = "location-recenthires";
    request.aggregatescount = this.aggregatescount;

    this.personSearchService.getTotalAggs(request).subscribe(response => {
      this.locationAPiCalled = true;
      const tempData = response?.data?.aggregations && response?.data?.aggregations["location-recenthires"] 
        ? response?.data?.aggregations["location-recenthires"] : [];
      this.totalResultCount = response.data.totalresultscount;
      this.locationSortData = tempData;
      this.totalCount = tempData.length;
      this.locationsData = this.locationSortData?.slice(this.start, this.end);
      this.locations = new MatTableDataSource(this.locationsData);
      this.locations.sort = this.locationTbSort;
      this.markMap();
      this.manualSort();
      this.getlocationsai(this.locationSortData);
    });
  }

/**
 * Mark locations on page according to data on each page
 */
  markMap(){
    const CharForworkCountry = [];
    CharForworkCountry.push(['Location', 'Professional count'])
    this.locationsData.forEach(x => {
      const dataObj = [`${x.key.charAt(0).toUpperCase()}${x.key.slice(1)}`, x.doc_count];
      CharForworkCountry.push(dataObj);
    });
    this.dataSourceWorkCountry = CharForworkCountry;
    setTimeout(() => {
      this.loadGoogleMap();
    });
  }

  /**
   * 
   */
  loadGoogleMap() {
    function drawMarkersMap() {
      var data = google.visualization.arrayToDataTable(this.dataSourceWorkCountry);
      var options = {
        region: `${CONTINENT_MAP[this.localstorageservice.getItem('talentRegion')]}`,
        displayMode: 'markers',
        colorAxis: { colors: ['#ff7f7f', '#ffff32', '#4292ff'] }
      };
      const container = document.getElementById('workCountryChart');
      var chart = new google.visualization.GeoChart(container);
      chart.draw(data, options);
    }

    google.charts.load('current', {
      'packages': ['geomap', 'geochart'],
      'mapsApiKey': environment.mapskey
    });
    google.charts.setOnLoadCallback(drawMarkersMap.bind(this));
  }

  manualSort(){
    this.reSortArr(this.locationTbSort);
  }

  /**Sort the data from all the pages present inititally */
  reSortArr(sort: MatSort){
    const tempData = this.locationSortData;
    if(!this.hasSortSelection(sort)) {
      this.setDefaultLocationData(tempData);
      return;
    }
    this.setLocationSortData(tempData, sort);
    this.setSortedLocationData();
    this.markMap();
  }

  private setLocationSortData(tempData: any, sort: MatSort) {
    this.locationSortData = tempData.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'doc_count': return this.compare(a.doc_count, b.doc_count, isAsc);
        case 'recent_hires': return this.compare(a.recenthires, b.recenthires, isAsc);
        default: return 0;
      }
    });
  }

  private setDefaultLocationData(tempData: any) {
    this.locationsData = tempData.slice(this.start, this.end);
    this.locations = new MatTableDataSource(this.locationsData);
    this.locations.sort = this.locationTbSort;
  }

  private setSortedLocationData() {
    this.locationsData = this.locationSortData.slice(this.start, this.end);
    this.locations = new MatTableDataSource(this.locationsData);
    this.locations.sort = this.locationTbSort;
  }

  private hasSortSelection(sort: MatSort) {
    return sort && sort.active && sort.direction;
  }

  compare(a, b, isAsc:boolean){
    return(a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  /**
   * 
   * @param index returns the index of current page
   */
  setPage(index: number) {
    this.start = (index - 1) * this.pageSize;
    this.end = this.start + this.pageSize;
    this.currentPage = index;
    if(this.aggregatescount / this.pageSize <= index){
      this.aggregatescount = this.aggregatescount + this.pageSize;
      this.getTopLocationsV2();
    }
    else{
      this.manualSort();
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  /**
   * Handel Redirection to person search listing
   * @param type
   * @param key
   */
  handelRedirection(type: string, key: string) {
    if(this.isLocationEurope) return;

    const additionalFilters = {};
    switch(type) {
      case 'location': additionalFilters['mandatorylocations'] = [key]; break;
      case 'recent_hires': {
        additionalFilters['mandatorylocations'] = [key]; 
        additionalFilters['recentcompanyhires'] = true;
        break;
      }
    }

    this.talentfilterdata.additionalFilters = additionalFilters;
    const uniqueHash = this.hashService.generateUniqueHash();
    this.talentInsightsReqHandlerService.setSessionDataForCurrentRedirection(uniqueHash, this.talentfilterdata);
    const aggReq = this.aggService.getRequestWithFilters();
    const url = `/person/search/listing?redirectSource=talent-insights&${GeneralConstants.LS_KEYS.UNIQUE_HASH}=${uniqueHash}&keyword=${aggReq.booleanquery!= '*' ? aggReq.booleanquery: ''}`; 
    window.open(url, "_blank");
  }

  getlocationsai(data) {
    let locationsdata : {'Top Cities': string, 'Talent Count': number, 'Recent Hires': number}[];
    locationsdata = data.map(x => {
      return {
        'Top Cities': x.key,
        'Talent Count': x.doc_count,
        'Recent Hires': x.recenthires
      };
    });
    this.locationsdataAI = {
      locations: locationsdata
    }
    if(this.locationsData.length == 0)
      this.locationsdataAI = null;
  }

  /**
   * Share data with parent to initiate insights-export
   * @param requestData 
   */
  shareDataForInsightsExport(requestData: { type?: string, action?: string, data?: { currentTab?: string } }) {
    if(requestData?.data?.currentTab !== 'location') return;

    const payloadForInsightsExport = {
      tab: 'location',
      totalresultcount: this.totalResultCount,
      chartdetails: [{ type: 'google', data: this.dataSourceWorkCountry }],
      locations: this.locationSortData
    }
    this.talentInsightsService.sendInsightsExportData(payloadForInsightsExport);
  }
}
